
class WineListModal {
    constructor() {
        this.modal = document.querySelector('[data-wine-list-modal]');
        this.trigger = document.querySelector('[data-wine-list-trigger]');
        this.closeButtons = document.querySelectorAll('[data-wine-list-close]');
        this.iframe = this.modal?.querySelector('.wine-list-modal__iframe');
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.init();
    }

    init() {
        this.trigger?.addEventListener('click', () => this.open());
        this.closeButtons.forEach(button => {
            button.addEventListener('click', () => this.close());
        });
    }

    open() {
        this.modal?.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.handleKeyDown);
        // Focus close button for accessibility
        setTimeout(() => {
            this.modal?.querySelector('.wine-list-modal__close')?.focus();
        }, 100);
    }

    close() {
        this.modal?.classList.remove('is-active');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown(e) {
        if (e.key === 'Escape') {
            this.close();
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new WineListModal();
});
